export const DOMAIN = {
  beta: 'test',
  gamma: 'test',
  prod: 'prod',
};

export const REALM = {
  'eu-west-1': 'EUAmazon',
  'us-east-1': 'USAmazon',
  'us-west-2': 'FEAmazon',
};

export const SITE = {
  beta: 'AACChrome.Beta',
  gamma: 'AACChrome.Gamma',
  prod: 'AACChrome.Prod',
};

const footerToggleEndpoint = '/common/forceDesktopSite?force_desktop_site=';
export const FOOTER_FORCE_DESKTOP_ENDPOINT = `${footerToggleEndpoint}true&ref=`;
export const FOOTER_FORCE_MOBILE_ENDPOINT = `${footerToggleEndpoint}false&ref=`;
export const CONSOLE_HEADER_SECTION_ID = '#console-header-section';
export const CONSOLE_HEADER_RESIZE_EVENT = 'ChromeHeaderResize';
export const MOBILE_MENU_Z_INDEX = 398; // mobile menu
export const MOBILE_MENU_SUB_MENU_Z_INDEX = 399; // account, user preferences and tools menu

export enum WeblabedFeatures {
  STARDUST_BANNER_UI = 'STARDUST_BANNER_UI',
  UI_CALLS_AJAX = 'UI_CALLS_AJAX',
  CURRENCY_VISUALISATION = 'CURRENCY_VISUALISATION',
  PN_CHROME_ONBOARDING = 'PN_CHROME_ONBOARDING',
  PN_CSR = 'PN_CSR',
  ATC_USER_PROFILE = 'ATC_USER_PROFILE',
  BELL_DRAWER_TACTICAL_CARD_V2 = 'BELL_DRAWER_TACTICAL_CARD_V2',
  AAC_Chrome_Config_Capture = 'AAC_CHROME_CONFIG_CAPTURE',
  CENTRIC_MIGRATION_T1 = 'CENTRIC_MIGRATION_T1',
  CENTRIC_MIGRATION_T2 = 'CENTRIC_MIGRATION_T2',
  STARDUST_PAGE_LEVEL_BANNER_UI = 'STARDUST_PAGE_LEVEL_BANNER_UI',
  AAC_NAV_TEST = 'AAC_NAV_TEST',
  AAC_NAV_EXPERIMENT = 'AAC_NAV_EXPERIMENT',
}

export enum Components {
  HEADER = 'AACChromeHeader',
  FOOTER = 'AACChromeFooter',
  NAV = 'AACChromeNav',
  PIVOT_NAV = 'AACChromePivotNav',
  PAGE_HEADER = 'AACChromePageHeader',
  GLOBAL_HEADER = 'AACChromeGlobalHeader',
  MARKETPLACE_SWITCHER = 'AACChromeMarketplaceSwitcher',
}

// noop for reference comparison
export const noop = () => {};

export const CHROME_APP_NAME = {
  Header: 'Header',
  Nav: 'Nav',
  PivotNav: 'PivotNav',
  Footer: 'Footer',
  GlobalHeader: 'GlobalHeader',
  PageHeader: 'PageHeader',
  MarketplaceSwitcher: 'MarketplaceSwitcher',
};

export const staticImgSrcWithCache =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-logo._CB642372822_.svg';
export const staticInternalImgSrcWithCache =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-internal-logo._CB642372822_.svg';
export const staticImgSrc =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-logo.svg';
export const staticInternalImgSrc =
  'https://m.media-amazon.com/images/G/01/CCX/svg/amazon-ads-internal-logo.svg';

export const spoofingQueryParamName = 'kerberos';
export const quitSpoofingQueryParamValue = 'off';
export const ATC_EXTERNAL_TOGGLE = 'ATC_EXTERNAL_TOGGLE';
